import React from 'react';
import { CarouselAuctionDetails } from '../carousel/CarouselAuctionDetails';
import i18n from '../../i18n';
import {
  getAuction,
  addViewCount,
  toggleWishlist,
  toggleLike,
  toggleCalendar,
} from '../../models/auctions';
import { formatCurrency } from '../../state/utils';
import { Helmet } from 'react-helmet';
import { baseUrl } from '../../constants/global';
import swal from 'sweetalert';
import getServerTime from '../../models/server';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import { SaudiRiyalLogo } from '../logo/saudiLogo';
import { SimilarAuctions } from './auctionsCategory/similar';
import { BiddingComp } from '../helpers/biddingComp';

let is_logged = localStorage.getItem('is_logged_in') ? true : false;
let current_lng = localStorage.getItem('I18N_LANGUAGE');

export class AuctionDetails extends React.Component {
  constructor(props) {
    super(props);
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf('/') + 1, path.length);
    this.state = {
      wishlist: false,
      like: false,
      calendar: false,
      auctionId: auctionId,
      auction: [],
      vehicle_info: "",
      toggleArrow: false,
      bid_increment: 0,
      current_bid_amount: 0,
      user_bid_amount: 0,
      left_button_disable: true,
      is_bid_sending: false,
      bid_place_message: '',
      enquiries: [{ label: '', value: '' }],
      is_loading: false,
      bidTimeStopped: false,
      now: () => {
        let time = new Date().toLocaleTimeString('en-US', {
          timeZone: 'Asia/Riyadh',
        });
        let dt = new Date().toISOString('en-US').split('T')[0];
        let newDt = dt + ' ' + time;
        newDt = new Date(newDt.replace(/-/g, '/'));
        return newDt;
      },
    };

    this.updateMetaTags = this.updateMetaTags.bind(this);
    this.addWishList = this.addWishList.bind(this);
    this.addLike = this.addLike.bind(this);
    this.addCalendar = this.addCalendar.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.addViewCount();
    this.loadAuction();
    this.setServerTime();

    // Store interval ID so we can clear it later
    this.auctionInterval = setInterval(() => {
      if (!this.state.is_loading) {
        this.loadAuction();
      }
    }, 5000);
  }

  componentWillUnmount() {
    if (this.auctionInterval) {
      clearInterval(this.auctionInterval);
    }
  }


  componentDidCatch(error, errorInfo) {
    console.error('Enrollment Error:', error, errorInfo);
    this.setState({ hasError: true });
  }
  async setServerTime() {
    try {
      let response = await getServerTime();
      let serverTime = new Date(response.server_time.replace(/-/g, '/'));
      this.setState({ now: () => serverTime });
    } catch (error) {
      console.error('Error fetching server time:', error);
    }
  }

  updateMetaTags(auction) {
    let { id, title, images, description } = auction;

    let first_image = images && images.length > 0 ? images[0].image : false;
    let url = baseUrl + 'auction-details/' + id;

    const updatedMetaTags = [
      { property: 'og:title', content: title },
      { property: 'og:type', content: 'Auctions' },
      { property: 'og:url', content: url },
      { property: 'og:site_name', content: 'Mzadcom' },
      { property: 'og:description', content: description },
      { property: 'og:image', content: first_image },
      { name: 'twitter:card', content: 'app' },
      { name: 'twitter:title', content: 'Mzadcom Auctions' },
      { name: 'twitter:text:title', content: 'Mzadcom Auctions' },
      { name: 'twitter:image', content: first_image },
      { name: 'twitter:description', content: description },
    ];

    return (
      <Helmet>
        <title>{title}</title>
        {updatedMetaTags.map((tag, index) => (
          <meta key={index} {...tag} />
        ))}
      </Helmet>
    );
  }

  async addViewCount() {
    await addViewCount({ auction_id: this.state.auctionId });
  }

  async loadAuction() {
    this.setState({ is_loading: true });
    let id = this.state.auctionId;
    const response = await getAuction(id);
    if (response) {
      let auction = response.data;
      let enquiry = auction.enquiry;
      auction.selected_mask = auction.mask;
      this.setState({
        auction: auction,
        vehicle_info: auction.vehicle_info,
        current_bid_amount: auction.start_amount,
        enquiries: enquiry,
        is_loading: false,

      });
      this.setState({ like: auction.auction_liked });
      this.setState({ wishlist: auction.auction_wishlisted });
      this.setState({ calendar: auction.calendar });
    }
  }

  async addWishList(wishlist) {
    let { auction } = this.state;
    if (is_logged) {
      const response = await toggleWishlist({
        auction_id: auction.id,
        wishlist,
      });
      if (response) {
        this.setState({ wishlist: wishlist });
      }
    }
  }

  async addLike(like) {
    let { auction } = this.state;
    if (is_logged) {
      const response = await toggleLike({
        auction_id: auction.id,
        like,
      });
      if (response) {
        this.setState({ like: like });
      }
    }
  }

  async addCalendar(calendar) {
    let { auction } = this.state;
    if (is_logged) {
      const response = await toggleCalendar({
        auction_id: auction.id,
        calendar,
      });
      if (response) {
        this.setState({ calendar: calendar });
        if (calendar) {
          swal('Success', i18n.t('added_to_calendar'), 'success');
        } else {
          swal('Success', i18n.t('removed_from_calendar'), 'success');
        }
      }
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, '/')) : null;
  }

  render() {
    const { auction, vehicle_info } = this.state;

    const splitVehicleNumber = (vehicleNumber) => {
      if (!vehicleNumber) return { number: '60', letters: 'س' };

      // Remove extra spaces and trim
      const cleaned = vehicleNumber.trim().replace(/\s+/g, ' ');

      // Try to split by space first
      if (cleaned.includes(' ')) {
        const parts = cleaned.split(' ');
        return {
          number: parts[0] || '60',
          letters: parts.slice(1).join(' ') || 'س'
        };
      }

      // If no space, try to separate numbers from letters/arabic characters
      const match = cleaned.match(/^(\d+)(.*)$/);
      if (match) {
        return {
          number: match[1] || '60',
          letters: match[2].trim() || 'س'
        };
      }

      // Fallback: check if it starts with letters/arabic
      const reverseMatch = cleaned.match(/^([^\d]+)(\d+)$/);
      if (reverseMatch) {
        return {
          number: reverseMatch[2] || '60',
          letters: reverseMatch[1].trim() || 'س'
        };
      }

      return { number: cleaned || '60', letters: 'س' };
    };

    const vehicleParts = splitVehicleNumber(auction?.vehicle_info?.vehicle_number);


    let email_cont = `mailto:your@friendsmail.com?subject=${auction.title}&body=${auction.description}\r\n${window.location.href}`;
    let action_name = current_lng === 'ar' ? auction.title_ar : auction.title;
    let vehicle_color = current_lng === 'ar' ? vehicle_info?.color_ar : vehicle_info.color;
    let auction_description = current_lng === 'ar' ? auction.description_ar : auction.description; 
    let auction_location = current_lng === 'ar' ? auction.location_ar : auction.location; 
    //let start_date = auction.start_date_formatted;
    //let end_date = auction.end_date_formatted;
    let auction_images = auction.images;
    const currentDate = new Date();
    const auctionStartDate = new Date(auction.start_date);
    let can_show_end_clock = true;

    let url = baseUrl + 'auction-details/' + auction.id;

    if (auctionStartDate > currentDate) {
      can_show_end_clock = false;
    }

    let enquiries = auction.enquiry;
    let enquiry_length = (auction && auction.enquiry && auction.enquiry.length) || 0;
    let startDateAr = auction.start_date_ar;
    let endDateAr = auction.end_date_ar;

    let end_time = endDateAr && endDateAr['time'] ? endDateAr['time'] : '';
    end_time = end_time.replace('PM', i18n.t('PM'));
    end_time = end_time.replace('AM', i18n.t('AM'));
    let start_time = startDateAr && startDateAr['time'] ? startDateAr['time'] : '';
    start_time = start_time.replace('PM', i18n.t('PM'));
    start_time = start_time.replace('AM', i18n.t('AM'));
    let guarantee_amount = Number(auction.guarantee_amount);

    let updatedMetaTags = '';
    if (auction && auction.id) {
      updatedMetaTags = this.updateMetaTags(auction);
    }
    let addCalendarClass = 'p-2 text_div btn-primary-custom  rounded-5 btn-block border border-1';
    if (this.state.calendar) {
      addCalendarClass = 'p-2 text_div btn btn-danger rounded-5 btn-block border border-1';
    }
    return (
      <>
        <div className="auction-details-container page-container">
          <div className="header pt-5">
            <h1 style={{ fontWeight: 'bolder' }}>{action_name}</h1>
            <nav>
              <h5>MZADSA{auction.id}</h5>
            </nav>
          </div>

          <div className="auction-content row">
            <div className="left-column col-md-8">
              <div className="carousel-section">
                {auction_images && auction_images.length > 0 && (
                  <>
                    {auction.status_dis === 'A' && (
                      <div className="rounded-pill p-1 m-4 px-4 active_cus success">
                        <span>{i18n.t('active')}</span>
                      </div>
                    )}
                    {auction.status_dis === 'E' && (
                      <div className="rounded-pill p-1 px-4 active_cus danger">
                        <span>{i18n.t('expired')}</span>
                      </div>
                    )}
                    {auction.status_dis === 'U' && (
                      <div className="rounded-pill p-1 px-4 active_cus info">
                        <span>{i18n.t('upcoming')}</span>
                      </div>
                    )}
                    {auction.status_dis === 'F' && (
                      <div className="rounded-pill p-1 px-4 active_cus warning">
                        <span>{i18n.t('featured')}</span>
                      </div>
                    )}
                    <CarouselAuctionDetails images={auction_images} />
                  </>
                )}

                <div className="image-actions">
                  <button
                    className={`action-btn ${this.state.like ? 'active' : ''}`}
                    onClick={(event) => {
                      this.addLike(!this.state.like);
                    }}
                  >
                    <i
                      className={this.state.like ? 'fa fa-thumbs-o-up liked' : 'fa fa-thumbs-o-up'}
                    ></i>
                    {auction.likes}
                  </button>
                  <button
                    className={`action-btn ${this.state.wishlist ? 'active' : ''}`}
                    onClick={(event) => {
                      this.addWishList(!this.state.wishlist);
                    }}
                  >
                    <i className={this.state.wishlist ? 'fa fa-heart liked' : 'fa fa-heart'}></i>
                    {auction.likes}
                  </button>
                  <button className="action-btn">
                    <i className="fa fa-eye"></i>
                    {auction.total_views}
                  </button>

                  <button className="action-btn">
                    {i18n.t('bid_counr')} #{auction.bid_count}
                  </button>
                </div>
              </div>

              <div className="description-section">
                <h2>{action_name}</h2>
                <p className="price">{auction.price}</p>
                <p className="description">{auction_description}</p>

                <div className="specs-section">
                  {/* <h3>Info</h3> */}
                  <div className="specs-grid">
                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('auction_id')} :</span>
                      <span className="spec-value">MZADSA{auction.id}</span>
                    </div>

                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('location')} :</span>
                      <span className="spec-value">{auction_location}</span>
                    </div>

                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('start_bid_amount')} :</span>
                      <span className="spec-value">
                        <b>
                          {formatCurrency(auction.start_amount)} <SaudiRiyalLogo />
                        </b>{' '}
                      </span>
                    </div>

                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('current_amount')} :</span>
                      <span className="spec-value">
                        <b>
                          {formatCurrency(auction.current_amount)} <SaudiRiyalLogo />
                        </b>
                      </span>
                    </div>

                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('gurantee_amount')} :</span>
                      <span className="spec-value">
                        <b>
                          {formatCurrency(guarantee_amount)} <SaudiRiyalLogo />
                        </b>
                      </span>
                    </div>

                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('vat')}:</span>
                      <span className="spec-value">
                        {' '}
                        <b>{auction.vat} % </b>
                      </span>
                    </div>


                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('start_date')} :</span>
                      <span className="spec-value">
                        {' '}
                        {startDateAr && startDateAr['date'] ? startDateAr['date'] : ''} (
                        {start_time})
                      </span>
                    </div>

                    <div className="spec-item">
                      <span className="spec-label">{i18n.t('end_date')} :</span>
                      <span className="spec-value">
                        {' '}
                        {endDateAr && endDateAr['date'] ? endDateAr['date'] : ''} ({end_time})
                      </span>
                    </div>

                    {vehicle_info?.vehicle_number && <>
                      <div className="spec-item">
                        <span className="spec-label">{i18n.t("vehicle_number")}</span>
                        <div className="license-plate-display">
                          <div className="plate-container">
                            <div className="plate-number">{vehicleParts.number}</div>
                            <div className="plate-emblem">

                              <img className="saudi-emblem" src="/assets/images/SaudiArabia.png" />
                            </div>
                            <div className="plate-letter">{vehicleParts.letters}</div>
                          </div>
                          <div className="plate-footer">
                            <span className="plate-country">KSA</span>
                          </div>
                        </div>
                      </div>
                    </>}

                    {vehicle_info?.color && <>
                      <div className="spec-item">
                        <span className="spec-label">{i18n.t('vehicle_color')} :</span>
                        <span className="spec-value">
                          {' '}
                          <b>{vehicle_color}</b>
                        </span>
                      </div>
                    </>}

                    {vehicle_info?.model && <>
                      <div className="spec-item">
                        <span className="spec-label">{i18n.t('vehicle_model')} :</span>
                        <span className="spec-value">
                          {vehicle_info?.model}
                        </span>
                      </div>
                    </>}

                    {vehicle_info?.year && <>
                      <div className="spec-item">
                        <span className="spec-label">{i18n.t('vehicle_model')} :</span>
                        <span className="spec-value">
                          {vehicle_info?.year}
                        </span>
                      </div>
                    </>}


                    <div className="w-full"></div>
                  </div>
                  <div className="m-3">
                    <h6
                      className="text-center"
                      style={{
                        background: 'linear-gradient(45deg, #189397, #4fc1c0)',
                        color: '#fff',
                        padding: '10px',
                        borderRadius: '20px',
                      }}
                    >
                      {i18n.t("final_approval_lbl")}
                    </h6>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-4 col-4">
                  <div className="auction-info document-info">
                    <span className="details-title"></span>
                    <div className="card-body text-center">
                      <div className="mb-3">
                        <i
                          className="fa fa-file-pdf-o"
                          style={{
                            color: '#FF0000',
                            fontSize: '3rem',
                            background: '#f8f9fa',
                            // padding: '15px',
                            borderRadius: '12px',
                          }}
                        ></i>
                      </div>

                      <span className="d-block mb-3 fw-medium document-title">
                        {i18n.t('contracts')}
                      </span>

                      <button
                        type="button"
                        className="btn btn-primary btn-sm rounded-2"
                        onClick={() => {
                          if (!auction.file_payment_terms) {
                            swal(
                              'Failed',
                              'No files were found!!. Please contact mzadcom administrator',
                              'error'
                            );
                            return;
                          }
                          window.open(auction.file_payment_terms, '_blank');
                        }}
                      >
                        <i className="fa fa-eye me-1" />
                        {i18n.t('preview')}
                      </button>
                    </div>
                    {/* <AuctionDocuments auction={auction} lng={current_lng} /> */}
                  </div>
                </div>

                <div className="col-md-4 col-4">
                  <div className="auction-info document-info">
                    {/* {this.state.expand_pay_terms && ( */}

                    <div className="card-body text-center">
                      <div className="mb-3">
                        <i
                          className="fa fa-file-pdf-o"
                          style={{
                            color: '#FF0000',
                            fontSize: '3rem',
                            background: '#f8f9fa',
                            // padding: '15px',
                            borderRadius: '12px',
                          }}
                        ></i>
                      </div>

                      <span className="d-block mb-3 fw-medium document-title">
                        {i18n.t('terms_conditions_payment')}
                      </span>

                      <button
                        type="button"
                        className="btn btn-primary btn-sm rounded-2"
                        onClick={() => {
                          if (!auction.file_payment_terms) {
                            swal(
                              'Failed',
                              'No files were found!!. Please contact mzadcom administrator',
                              'error'
                            );
                            return;
                          }
                          window.open(auction.file_payment_terms, '_blank');
                        }}
                      >
                        <i className="fa fa-eye me-1" />
                        {i18n.t('preview')}
                      </button>
                    </div>

                    {/* )} */}
                  </div>
                </div>

                <div className="col-md-4 col-4">
                  <div className="auction-info document-info">
                    <div className="card-body text-center">
                      <div className="mb-3">
                        <i
                          className="fa fa-file-pdf-o"
                          style={{
                            color: '#FF0000',
                            fontSize: '3rem',
                            background: '#f8f9fa',
                            // padding: '15px',
                            borderRadius: '12px',
                          }}
                        ></i>
                      </div>

                      <span className="d-block mb-3 fw-medium document-title">
                        {i18n.t('terms_conditions')}
                      </span>

                      <button
                        type="button"
                        className="btn btn-primary btn-sm rounded-2"
                        onClick={() => {
                          if (!auction.file_terms) {
                            swal(
                              'Failed',
                              'No files were found!!. Please contact mzadcom administrator',
                              'error'
                            );
                            return;
                          }
                          window.open(auction.file_terms, '_blank');
                        }}
                      >
                        <i className="fa fa-eye me-1" />
                        {i18n.t('preview')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="mt-3">
              <AuctionsDetailTabs auction={auction} enquiries={this.state.enquiries} />
            </div> */}
            </div>

            <div className="right-column col-md-4">
              {/* <div className="auction-info">
                <div className=" rounded-pill border bg-white text-center">
                  <button
                    class={addCalendarClass}
                    onClick={(event) => {
                      this.addCalendar(!this.state.calendar);
                    }}
                    type="button"
                  >
                    <i className=" mdi mdi-calendar-plus text-white" />
                    <span className=" custom_text_white ms-2">
                      {this.state.calendar
                        ? i18n.t("remove_from_calendar")
                        : i18n.t("add_to_calendar")}
                    </span>
                  </button>
                </div>
              </div> */}

              <div className="mb-3">
                {this.state.auctionId && auction && (
                  <BiddingComp auction={auction} lng={current_lng} />
                )}
              </div>


              <div className="auction-info">
                {auction.latitude && auction.longitude && (
                  <>
                    <iframe
                      title="auction-location"
                      width="100%"
                      height="250"
                      style={{ border: 0, borderRadius: '10px' }}
                      src={`https://maps.google.com/maps?q=${auction.latitude},${auction.longitude}&z=15&output=embed`}
                      allowFullScreen
                      loading="lazy"
                    ></iframe>

                    <div className="text-center mt-2">
                      <a
                        href={`https://www.google.com/maps?q=${auction.latitude},${auction.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary-custom"
                      >
                        {i18n.t('open_google_map')}
                      </a>
                    </div>
                  </>
                )}
              </div>

              <div className="auction-info">
                <p className="">  {i18n.t('share_auction')}</p>
                <div className="">
                  <ul
                    className="d-flex justify-content-around m-0 p-0 gap-5"
                    style={{ listStyle: 'none' }}
                  >
                    <li>
                      <WhatsappShareButton url={url} title={auction.title}>
                        <WhatsappIcon size={40} round />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <FacebookShareButton url={url} quote={auction.title}>
                        <FacebookIcon size={40} round />
                      </FacebookShareButton>
                    </li>
                    <li>
                      <TwitterShareButton url={url} title={auction.title}>
                        <TwitterIcon size={40} round />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <LinkedinShareButton url={url} title={auction.title}>
                        <LinkedinIcon size={40} round />
                      </LinkedinShareButton>
                    </li>
                  </ul>
                </div>
              </div>

              {enquiry_length > 0 && (
                <div className="auction-info">
                  <p className="m-2">{i18n.t("enquiry")}</p>
                  <table className="mb-0 mt-2 rounded-4">
                    <tbody>
                      {enquiries.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td>
                              {current_lng === 'ar' && item.label_ar ? item.label_ar : item.label}
                            </td>
                            <td>
                              {current_lng === 'ar' && item.value_ar ? item.value_ar : item.value}
                            </td>
                            <td>
                              <a href="tel:{item.value}">
                                <i className="fa fa-phone me-2 text-black"></i>
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

              {/* <div className="auction-info">
              <AuctionDocuments auction={auction} lng={current_lng} />
            </div> */}

              {/* <div className="auction-info">
              <h3>Auction Information</h3>
              <div className="info-item">
                <span className="info-label">Auction ID:</span>
                <span className="info-value">{auction.id}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Location:</span>
                <span className="info-value">{auction.location}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Time Left:</span>
                <span className="info-value">{auction.timeLeft}</span>
              </div>
            </div> */}

            </div>
          </div>

          <div></div>

        </div>
        {/* <div className="col-md-12">
          <div className="items-gallery">
            <div className="items-blog-tab text-center">
              <div className="tab-content auc-card-wrapper">
                <div className="tab-pane active">
                  <SimilarAuctions
                    type={this.state.selectedTab}
                    getActiveCount={this.getActiveCount}
                    getImagePopup={this.getImagePopup}
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </>
    );
  }
}
